import * as React from "react";
import { useHistory } from "react-router-dom";
import { withReturnJob } from "../../../../../hooks/useInAppHistory";
import { Button, ButtonVariant } from "../../../../ui";

/** The tab replaces the Job History row, so wherever it dead-ends it must still lead there. */
export const CustomerHistoryLink: React.FC<{ contactId?: string | null; jobId?: string | null }> = ({
  contactId,
  jobId,
}) => {
  const history = useHistory();
  if (!contactId) return null;
  return (
    <Button
      variant={ButtonVariant.OUTLINED}
      onClick={() => history.push(withReturnJob(`/jobs-history/${contactId}`, jobId))}
      style={{ textTransform: "none", fontWeight: 600, minHeight: 44 }}
    >
      View customer job history
    </Button>
  );
};
